import React, { useEffect, useRef, useState } from "react";
import styles from "./listSorter.module.css";
import IMAGES from "../../assets/images/images";

const ListSorter = ({
  options = [],
  sortConfig,
  onChange,
  label = "Sort by",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedOption = options.find(
    (option) =>
      option.field === sortConfig?.field &&
      option.order === sortConfig?.order
  );

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () =>
      document.removeEventListener(
        "mousedown",
        handleOutsideClick
      );
  }, []);

  const handleSelect = (option) => {
    onChange({
      field: option.field,
      order: option.order,
    });

    setIsOpen(false);
  };

  return (
    <div className={styles.container} ref={dropdownRef}>
      <div
        className={styles.selectedOption}
        onClick={() => setIsOpen((prev) => !prev)}
      > <div className={styles.columnkey}>{label}:</div>
        <div className={styles.columnname}>
           {selectedOption?.label}
        </div>
        {/* <span
          className={`${styles.arrow} ${
            isOpen ? styles.arrowOpen : ""
          }`}
        > */}
          <img className={`${styles.arrows} ${isOpen ? styles.rotateArrow : ""}`} src={IMAGES.arrowdown} alt="dropdown arrow"/>
        {/* </span> */}
      </div>

      {isOpen && (
        <div className={styles.dropdown}>
          {options.map((option) => {
            const isSelected =
              option.field === sortConfig?.field &&
              option.order === sortConfig?.order;

            return (
              <div
                key={`${option.field}-${option.order}`}
                className={`${styles.option} ${
                  isSelected ? styles.activeOption : ""
                }`}
                onClick={() => handleSelect(option)}
              >
                {option.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ListSorter;